module.exports = __webpack_public_path__ + "img/price1.f8700faa.svg";